module.exports = "dist/images/components-image-shape-control-circle.9bd9f74.png";